import React from "react";
import {
  Rowz,
  Wrapper
} from "../../../components/Layout/Layout";
import styles from "./Header.module.scss";

const tbClasses = [
  `${styles.tb_l_header} ${styles.tb_l_shadow__bottom} ${styles.tb_l_spacer}`
];
function Header(props) {
  return (
    <Rowz extraClassNames={tbClasses}>
      <Wrapper>{props.children}</Wrapper>
    </Rowz>
  );
}

export default Header;
